export enum GetStartedLocalStorageKeys {
  FORCE_GET_STARTED = 'shippo_get_started_force_show',
  SKIP_GET_STARTED = 'shippo_skip_get_started',
}

export const footerLinks = {
  personalFlow: [
    {
      translation: 'FooterLinkOne',
      slug: 'https://support.goshippo.com/hc/en-us/articles/4403206353051-How-to-Create-a-New-Label-in-Shippo',
    },
    {
      translation: 'FooterLinkThree',
      slug: 'https://support.goshippo.com/hc/en-us/articles/4403047372699-How-to-Connect-Your-E-Commerce-Store-to-Shippo#connect-stores-and-import-orders-0-0',
    },
    {
      translation: 'FooterLinkTwo',
      slug: 'https://support.goshippo.com/hc/en-us/sections/360001987251-How-to-Shippo-Video-Series',
    },
    {
      translation: 'FooterLinkFour',
      slug: 'https://support.goshippo.com/hc/en-us/articles/360003876372-Printer-and-Label-Size-Best-Practices',
    },
  ],
  businessFlow: [
    {
      translation: 'FooterLinkThree',
      slug: 'https://support.goshippo.com/hc/en-us/articles/4403047372699-How-to-Connect-Your-E-Commerce-Store-to-Shippo#connect-stores-and-import-orders-0-0',
    },
    {
      translation: 'FooterLinkFive',
      slug: 'https://support.goshippo.com/hc/en-us/articles/4403206353051-How-to-Create-a-New-Label-in-Shippo',
    },
    {
      translation: 'FooterLinkTwo',
      slug: 'https://support.goshippo.com/hc/en-us/sections/360001987251-How-to-Shippo-Video-Series',
    },
    {
      translation: 'FooterLinkFour',
      slug: 'https://support.goshippo.com/hc/en-us/articles/360003876372-Printer-and-Label-Size-Best-Practices',
    },
  ],
};
